import { Flex, Text } from "@chakra-ui/react";
import { useState, useEffect } from "react";
import InputComponent from "../../components/Input";
import { PixIcon } from "../../styles/icons/PixIcon";

export function PixSection({ organizateRateOld, setOrganizateRateNew, resetTrigger, onEdit }) {
  const [pixObjectOld, setPixObjectOld] = useState(null);
  const [pixObjectNew, setPixObjectNew] = useState(null);

  useEffect(() => {
    const pixOld = organizateRateOld?.GLOBAL?.find(
      (item) => item.paymentMethodModel?.name === "PIX"
    );

    if (pixOld) {
      setPixObjectOld(pixOld);
      setPixObjectNew(JSON.parse(JSON.stringify(pixOld)));
    }
  }, [organizateRateOld]);

  useEffect(() => {
    if (pixObjectOld) {
      setPixObjectNew(JSON.parse(JSON.stringify(pixObjectOld)));
    }
    //eslint-disable-next-line
  }, [resetTrigger]);

  function handleInputChange(field, newValue) {
    setPixObjectNew((prevPix) => {
      if (!prevPix) return prevPix;

      const updatedPix = JSON.parse(JSON.stringify(prevPix));

      if (field === "repaymentDay") {
        updatedPix.repaymentDayModel.day = newValue;
      }
      if (field === "paymentFeeValue") {
        updatedPix.rates[0].paymentFeeValue = newValue;
      }
      if (field === "rateLimitValue") {
        updatedPix.rates[0].rateLimitValue = newValue;
      }

      return updatedPix;
    });

    setOrganizateRateNew((prevRates) => {
      const updatedRates = JSON.parse(JSON.stringify(prevRates));
      const pixEntry = updatedRates?.GLOBAL?.find(
        (item) => item.paymentMethodModel?.name === "PIX"
      );

      if (pixEntry) {
        if (field === "repaymentDay") {
          pixEntry.repaymentDayModel.day = newValue;
        }
        if (field === "paymentFeeValue") {
          pixEntry.rates[0].paymentFeeValue = newValue;
        }
        if (field === "rateLimitValue") {
          pixEntry.rates[0].rateLimitValue = newValue;
        }
      }

      return updatedRates;
    });
  }
  if (!pixObjectNew) {
    return <Text>Carregando...</Text>;
  }

  return (
    <Flex flexDir="column" gap="26px">
      <Flex gap=".4rem" margin="1rem 0 0" alignItems="center">
        <PixIcon size={22} />
        <Text fontFamily="Hero New" fontWeight="600" fontSize="16px" >PIX</Text>
      </Flex>

      {pixObjectNew && (
        <Flex gap="34px"
        
        >
          <InputComponent
            topLabel="Tempo de repasse"
            value={pixObjectNew?.repaymentDayModel?.day || ""}
            isTransferTime={true}
            onChange={(newValue) => handleInputChange("repaymentDay", newValue)}
            onEdit={onEdit}
          />

          <InputComponent
            topLabel="Taxa"
            isPercentage={true}
            value={pixObjectNew?.rates[0]?.paymentFeeValue || ""}
            onChange={(newValue) => handleInputChange("paymentFeeValue", newValue)}
            onEdit={onEdit}
          />

          <InputComponent
            topLabel="Limite de taxas"
            isLimit={true}
            value={pixObjectNew?.rates[0]?.rateLimitValue || ""}
            onChange={(newValue) => handleInputChange("rateLimitValue", newValue)}
            onEdit={onEdit}
          />
        </Flex>
      )}
    </Flex>
  );
}
